import { render } from "./DeansComplianceCheckingDetails.vue?vue&type=template&id=760a370d"
import script from "./DeansComplianceCheckingDetails.vue?vue&type=script&lang=js"
export * from "./DeansComplianceCheckingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__